
import { useEffect, useState } from "react";

import {
	Grid,
	Typography,
	Select,
	MenuItem,
} from "@mui/material";

import { useSelector } from 'react-redux';

const ParametersBroker = ({ param, parameters, setParameters }) => {
	const [broker, setBroker] = useState(parameters.find((p) => p.id === param.id).value);
	const brokers = useSelector((state) => state.brokers);
	console.log("In broker dropdown", brokers);

	useEffect(() => {
		setBroker(parameters.find((p) => p.id === param.id).value);
	}, [parameters]);

	return (
		<Grid
			item
			container
			display="flex"
			direction="row"
			justifyContent="flex-start"
			alignItems="center"
			sx={{
				marginBottom: "5px",
				width: "100%",
			}}
		>
			<Typography sx={{ marginRight: "10px", width: "40%" }}>
				{param.label}
			</Typography>
			<Select
				variant="filled"
				sx={{
					width: "55%",
				}}
				value={broker ?? ""}
				onChange={(e) => {
					const newParams = parameters.map((p) => {
						if (p.id === param.id) {
							return {
								...p,
								value: e.target.value,
							};
						}

						return p;
					});
					setParameters(newParams);
				}}
			>
				<MenuItem
					key="none"
					value=""
				>
					{""}
				</MenuItem>
				{brokers.map((option) => (
					<MenuItem
						key={option.id}
						value={option.parameters.id}
					>
						{option.parameters.name}
						{" ("}
						{option.parameters.host}
						{":"}
						{option.parameters.port}
						{")"}
					</MenuItem>
				))}
			</Select>
		</Grid>
	);
};

export default ParametersBroker;
